import { Project } from '@prisma/client';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import { useCurrentProject } from '../../hooks/useCurrentProject';
import { useGetProjects } from '../projects/projects.queries';
import { EmptyUserReport } from './components/empty-user-report';

export const AutoUserRedirect = () => {
  const { projectId, workspaceId } = useParams();
  const { currentProject, projects, isLoading: isLoadingProjects } = useCurrentProject();

  // Show loading indicator while projects are loading
  if (isLoadingProjects) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If there are no projects at all
  if (!projects || projects.length === 0) {
    return <EmptyUserReport />;
  }

  // Determine project ID to work with
  let targetProjectId = projectId;

  // If no project ID in URL, use current project or first project
  if (!targetProjectId) {
    targetProjectId = currentProject ? String(currentProject.id) : String(projects[0].id);
    return <Navigate to={`/${workspaceId}/reports/${targetProjectId}`} replace />;
  }

  // Find project by ID
  const project = projects.find((p) => p.id === parseInt(targetProjectId || ''));

  // If project not found
  if (!project) {
    // If there are other projects, use the first one
    const firstProjectId = String(projects[0].id);
    return <Navigate to={`/${workspaceId}/reports/${firstProjectId}`} replace />;
  }

  // If project has no users
  if (!project.UserProject?.length) {
    return <EmptyUserReport />;
  }

  // If everything is OK, redirect to first user's page
  const firstUser = project.UserProject[0].user;
  return <Navigate to={`/${workspaceId}/reports/${targetProjectId}/user/${firstUser.id}`} replace />;
};
